import {AfterViewChecked, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {DatePipe, JsonPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {MatToolbarModule} from "@angular/material/toolbar";
import { ConsoleService, Log} from "../../service/console.service";
import {Subscription} from "rxjs";
import {MatTooltip} from "@angular/material/tooltip";


@Component({
  selector: 'app-debugger',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    NgForOf,
    NgIf,
    NgClass,
    MatSnackBarModule,
    DatePipe,
    JsonPipe,
    MatTooltip
  ],
  templateUrl: './debugger.component.html',
  styleUrl: './debugger.component.scss',
  providers: [ConsoleService]
})
export class DebuggerComponent implements OnInit, AfterViewChecked, OnDestroy{
  @ViewChild('logContainer') private logContainer: ElementRef | undefined;

  debuggerToggle = false;
  windowPin: string = "left";

  public logs: Log[] = [];
  private logsSubscription: Subscription | undefined;

  public autoscroll = true; // Autoscroll is enabled by default
  private shouldScroll = false;

  constructor(private consoleService: ConsoleService) {}

  ngOnInit(): void {
    this.consoleService.startCapturing();
    console.log('Console capturing started.');
    this.logsSubscription = this.consoleService.logs$.subscribe(logs => {
      // When new logs arrive, mark that we should scroll down
      this.shouldScroll = this.autoscroll;
      this.logs = logs;
    });
  }

  ngAfterViewChecked(): void {
    // After the view updates with new logs, scroll down if needed
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  private scrollToBottom(): void {
    if (this.logContainer) {
      try {
        this.logContainer.nativeElement.scrollTop = this.logContainer.nativeElement.scrollHeight;
      } catch (err) {
        console.error('Error scrolling to bottom:', err);
      }
    }
  }

  public toggleAutoscroll(): void {
    this.autoscroll = !this.autoscroll;
    // If autoscroll is re-enabled, scroll to the bottom immediately
    if (this.autoscroll) {
      this.shouldScroll = true;
    }
  }

  ngOnDestroy(): void {
    if (this.logsSubscription) {
      this.logsSubscription.unsubscribe();
    }
    setTimeout(() => {
      console.log('Console capturing stopped.');
      this.consoleService.stopCapturing();
    }, 0);
  }

  pinWindow(position: "full" | "top" | "bottom" | "left" | "right") {
    this.windowPin = position;
  }

  public onDebuggerToggle(): void {
    this.debuggerToggle = !this.debuggerToggle;
  }
}
